module.exports = __webpack_public_path__ + "static/media/serious.b4097a07.png";